import { render } from "./Main.vue?vue&type=template&id=799334ce"
const script = {}
script.render = render

export default script